import React from 'react';
import './test.css';
import instru from '../assets/instru1.png';
import avator from '../assets/avator.png';

const MusicTestimonials = () => {
  return (
    <div className="testimonial-bg">
      <section className="music-testimonials">
        {/* Left Side: Heading + Reviews */}
        <div className="testimonial-content-left">
          <div className="testimonial-left">
            <h2>
              <span className="highlighted-title">
                <span className="highlight-bar"></span>
                What Our Customers <br /> Are Saying
              </span>
            </h2>
            <p>
              Discover why learners and artists love our premium collection of music books. From beginner guides to advanced classical theory — everything you need for your musical journey.
            </p>
          </div>

          <div className="testimonial-right">
            <div className="review-card zigzag top">
              <img src={avator} alt="Aakash" className="profile-img" />
              <div className="stars">★★★★★</div>
              <p>
                These books helped me crack the basics of Hindustani music! Very structured and easy to follow.
              </p>
              <span className="reviewer">– Aakash R., Music Student</span>
            </div>

            <div className="review-card zigzag middle">
              <img src={avator} alt="Shruti" className="profile-img" />
              <div className="stars">★★★★★</div>
              <p>
                Brilliant theory books. My students finally understand taal and notation clearly!
              </p>
              <span className="reviewer">– Shruti B., Vocal Trainer</span>
            </div>

            <div className="review-card zigzag bottom">
              <img src={avator} alt="Rajesh" className="profile-img" />
              <div className="stars">★★★★☆</div>
              <p>
                Found a great tabla guide here. Very detailed and accurate.
              </p>
              <span className="reviewer">– Rajesh M., Music Teacher</span>
            </div>
          </div>
        </div>

        {/* Right Side: Image */}
        <div className="testimonial-image-right">
          <img src={instru} alt="Decor" />
        </div>
      </section>
    </div>
  );
};

export default MusicTestimonials;
